<template>
    <div class="w-full">
       <div class="flex items-center font-bold text-2xl justify-between mb-6">
         <h3>{{ title || 'Products' }}</h3>

        <div class="space-x-2">
            <UButton
                :disabled="!canScrollPrev"
            icon="i-heroicons-arrow-left" variant="outline" color="neutral" size="sm" @click="prev" />
            <UButton
                :disabled="!canScrollNext"
            icon="i-heroicons-arrow-right" variant="outline" color="neutral" size="sm" @click="next" />
        </div>

         </div>

            <UCarousel @select="onSelect" ref="carousel" :items="products" :ui="{
                item: 'basis-1/1 sm:basis-1/2 md:basis-1/3 lg:basis-1/4',
                container: 'pr-24'
            }">
            <template #default="{ item }">
                <ProductCard :product="item" />
            </template>
            </UCarousel>
    </div>
</template>

<script setup lang="ts">
import ProductCard from '~/components/molecules/ProductCard.vue'
import type { ListProduct } from '~/types';

defineProps<{
  title?: string
  products: ListProduct[]
}>()

const carousel = useTemplateRef<any>('carousel')

const canScrollPrev = ref(false)

const canScrollNext = ref(false)

const onSelect = () => {
  // Trigger re-computation of canScrollPrev and canScrollNext
  canScrollPrev.value = carousel.value?.emblaApi?.canScrollPrev() || false
  canScrollNext.value = carousel.value?.emblaApi?.canScrollNext() || false
}



const prev = () => {
  carousel.value.emblaApi.scrollPrev()
}

const next = () => {
  carousel.value.emblaApi.scrollNext()
}

</script>